import { AddFunnelMenu, AddFunnelMenuActions } from '../left-menu/AddFunnelMenu';
import { Box } from '@mui/material';
import { useCanvasToolbarContext } from './CanvasToolbarCtx';
import { useCallback } from 'react';

export const CanvasAddFunnelMenuButton = ({
  isDisabled,
}: {
  isDisabled?: boolean;
  onClickMenuItemCallback?: (action: AddFunnelMenuActions) => void;
}) => {
  const { setActiveExclusiveButton } = useCanvasToolbarContext();

  const onClickMenuItemCallback = useCallback(() => {
    setActiveExclusiveButton('addFunnelMenu');
  }, [setActiveExclusiveButton]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 4px',
        '& > div > span': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
      className="add-funnel-menu-button"
    >
      <AddFunnelMenu
        disabled={!!isDisabled}
        menuPlacement="top"
        allowedMenuActions={[
          AddFunnelMenuActions.IMPORT_FUNNEL,
          AddFunnelMenuActions.ADD_3TH_PARTY_FUNNEL,
        ]}
        anchorOrigin={{
          vertical: -32,
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 239,
        }}
        onClickMenuItemCallback={onClickMenuItemCallback}
      />
    </Box>
  );
};
